import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import * as api from "../../api/index";
import CustomerResultComponent from "../CustomerResult";
import '../../main.css';
import PropertyResultComponent from "../PropertyResult"
import { useTranslation } from "react-i18next";
import { Search } from "../../compositions/PropertyResult/component";
import "./style.css";
import FilterComponenent from "../Filter";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { useSelector, useDispatch } from "react-redux";
import { formatDateTime, isNullOrUndefined } from "../../utils/formatting";
import { resetReduxState } from "../../utils/resetReduxState/resetReduxState";
import { userChosenSearchText, userChosenBackButton, userChosenSearchType, userChosenRaisedSince, userChosenRaisedUpto, isSearch, userChosenBackValue, loadDuplicateRepairPage, userCreatedNewRepair, userChosenResumeRepair, userChosenCurrentValue, userChosenCustomerID } from "../../ducks/redux/actions/userChoices";
import { PermissionsList } from "../../models/Permissions";
import { workOrderRepairObject, getCustomerId, saveSubSessionAssetsEligibilityDetails } from "../../ducks/redux/actions/getAddress";
import WorkOrderResultComponent from "../WorkOrderResult";
import moment from "moment";
import CaseResultComponent from "../Cases/CaseResult";
import { SearchType } from "../../models/shared/Enum";
import { getCaseAssignToMeDataRemove, getSearchPropertyData, getSearchPropertyRemoveData, getSearchTypeCustomerData, getSearchTypeCustomerRemoveData, getSearchTypeServiceRequestData, getSearchTypeServiceRequestDataRemove, getSearchTypeSortData, getSearchTypeSortDataRemove, getSearchTypeWorkOrderData, getSearchTypeWorkOrderDataRemove } from "../../ducks/redux/actions/FinancialReferral";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getCaseData, getPropertyData, getCustomerData, getWorksOrdersApi } from "../APIErrorComponent/APIConstantName";
import { resetHazardAssessmentData } from "../../ducks/redux/actions/hazardAssessment";

interface LandingViewProps extends RouteComponentProps<any> { }

const LandingView: React.FC<LandingViewProps> = (props) => {

  const customerData = useSelector(
    (state: any) => state?.userChoicesReducer?.customersData
  );
  const dispatch = useDispatch();
  const array: any[] = [];
  const [addresses, setAddresses] = useState(array);
  const SearchValue = useSelector(
    (state: any) => state?.userChoicesReducer?.SearchType
  );
  const SearchText = useSelector(
    (state: any) => state?.userChoicesReducer?.SearchText
  );
  const BackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.BackButton
  );
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const searchTextCount = useSelector(
    (state: any) => state.userChoicesReducer?.searchTextCountValue
  );

  const isCaseCheck = useSelector(
    (state: any) => state?.userChoicesReducer?.isCaseAllowed
  );
  const loginStatus = useSelector((state: any) => state?.userChoicesReducer?.loginStatus);
  const isRepairMediaAllowed = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  const searchTextCountValue = useSelector((state: any) => state?.userChoicesReducer?.searchTextCountValue);
  const vandalismtoggleValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const isRepairCovidAllowed = useSelector((state: any) => state?.userChoicesReducer?.isRepairCovidAllowed);
  const demobilizedContractorSites = useSelector((state: any) => state?.userChoicesReducer?.demobilizedContractorSites);
  const skipResponsibilityCheckForEMA = useSelector(
    (state: any) => state?.userChoicesReducer?.skipResponsibilityCheckForEMA
  );
  const checkEnhancedRepairEligibilityP360 = useSelector((state: any) => state?.userChoicesReducer?.checkEnhancedRepairEligibilityP360);
  const isEDEnabled = useSelector((state: any) => state?.userChoicesReducer?.isEDEnabled);
  const isDMQuestionnaireEnabled = useSelector((state: any) => state?.userChoicesReducer?.isDMQuestionnaireEnabled);
  const isDMReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isDMReportPreferenceEnabled);
  const isHHRSReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isHHRSReportPreferenceEnabled);
  const DMReportingComplianceEffectiveDate = useSelector((state: any) => state?.userChoicesReducer?.DMReportingComplianceEffectiveDate);
  const isAdditionalDMWorkOrderRequired = useSelector((state: any) => state?.userChoicesReducer?.isAdditionalDMWorkOrderRequired);
  const woCreationTimeoutSeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationTimeoutSeconds);
  const woCreationPollingDelaySeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationPollingDelaySeconds);
  const caseManagementToggle = useSelector((state: any) => state?.caseCreationReducer?.isCaseManagementToggle);
  const updateAnActionToggle = useSelector((state: any) => state?.caseCreationReducer?.isUpdateAnActionToggle);
  const edConfigOverrideUrl = useSelector((state: any) => state?.userChoicesReducer?.edConfigOverrideUrl);
  const edConfigCustomer = useSelector((state: any) => state?.userChoicesReducer?.edConfigCustomer);
  const edConfigActiveHousingScriptUrl = useSelector((state: any) => state?.userChoicesReducer?.edConfigActiveHousingScriptUrl);
  const availabilityWaitTimeSeconds = useSelector((state: any) => state?.userChoicesReducer?.availabilityWaitTimeSeconds);
  const woCancellationTimeoutSeconds = useSelector((state: any) => state?.userChoicesReducer?.woCancellationTimeoutSeconds);
  const woCancellationPollingDelaySeconds = useSelector((state: any) => state?.userChoicesReducer?.woCancellationPollingDelaySeconds);
  const recallEligibilityPeriodInMonths = useSelector((state: any) => state?.userChoicesReducer?.recallEligibilityPeriodInMonths);
  // Getting all filtered data from stored
  const customerFilteredData = useSelector((state: any) => state?.financialReferralReducer?.searchTypeCustomer);
  const propertyFilteredData = useSelector((state: any) => state?.financialReferralReducer?.searchTypeProperty);
  const workOrderFilteredData = useSelector((state: any) => state?.financialReferralReducer?.searchTypeWorkOrder);
  const serviceRequestFilteredData = useSelector((state: any) => state?.financialReferralReducer?.searchTypeServiceRequest);
  const assignToMeData = useSelector((state: any) => state?.financialReferralReducer?.assignToMeData);
  const filteredDateFrom = useSelector((state: any) => state?.userChoicesReducer?.RaisedSince);
  const filteredDateTo = useSelector((state: any) => state?.userChoicesReducer?.RaisedUpto);
  const filteredSortData = useSelector((state: any) => state?.financialReferralReducer?.filterSortData)
  const [isSearchDropdown, setIsSearchDropdown] = useState(!!customerData?.searchText);
  const [searchText, setSearchText] = useState((customerData?.searchText) ?? '' );
  const [isLoading, setIsLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [customerStatus, setCustomerStatus] = useState(isNullOrUndefined(customerData?.customerType) ? customerFilteredData?.setCustomerStatus : customerData?.customerType);
  const [tenancyType, setTenancyType] = useState(isNullOrUndefined(customerData?.tenancyType) ? customerFilteredData?.setTenancyType : customerData?.tenancyType);
  const [sortValue, setSortValue] = useState(filteredSortData || '');
  const [propertyType, setPropertyType] = useState(propertyFilteredData?.setPropertyType || '');
  const [propertySortValue, setPropertySortValue] = useState(filteredSortData || '');
  const [disableSearchType, setDisableSearchType] = useState(true);
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(isNullOrUndefined(customerData?.currentPage) ? 0 : customerData?.currentPage)
  const [resultsPerPage, setResultsPerPage] = useState(isNullOrUndefined(customerData?.resultsPerPage) ? 10 : customerData?.resultsPerPage)
  const [skip, setSkip] = useState(isNullOrUndefined(customerData?.skip) ? 0 : customerData?.skip)
  const [workOrderPropertyType, setWorkOrderPropertyType] = useState(workOrderFilteredData?.setWorkOrderPropertyType || '');
  const [propertyStatus, setPropertyStatus] = useState(propertyFilteredData?.setPropertyStatus || '');
  const [statusWorkOrderType, setStatusWorkOrderType] = useState(workOrderFilteredData?.setStatusWorkOrderType || '');
  const [priorityWorkOrder, setPriorityWorkOrder] = useState(workOrderFilteredData?.setPriorityWorkOrder || '');
  const defaultfromdate = formatDateTime(moment(new Date()).subtract(6, "months").toString())
  const [raisedSince, setRaisedSince] = useState(filteredDateFrom || defaultfromdate);
  const defaultTodate = formatDateTime(moment(new Date()).toString())
  const [raisedUpto, setRaisedUpto] = useState(filteredDateTo || defaultTodate);
  const [isDateValid, setIsDateValid] = useState(true);
  const [dateErrorMessage, setDateErrorMessage] = useState('');
  const [caseSortValue, setCaseSortValue] = useState(filteredSortData || '');
  const [caseAssetType, setCaseAssetType] = useState(serviceRequestFilteredData?.setCasePropertyType || '');
  const [caseStatusType, setCaseStatusType] = useState(serviceRequestFilteredData?.setCaseStatusFilterType || '');
  const [isAssignedToMe, setIsAssignedToMe] = useState(assignToMeData || '');
  const [searchType, setSearchType] = useState('Select');
  let raisedSinceDate: any;
  let raisedUptoDate: any;
  const [cachedUserName] = useState(() => localStorage.getItem('userName') || "");
  const apiErrorsStore = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
  const isHHSRSEnabled = useSelector((state: any) => state?.financialReferralReducer?.isHHSRSEnabled)
  const isHHSRSRepairEnabledCheck = useSelector((state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled);
  let [apiErrors, setApiErrors] = useState({
    [getCustomerData]: false,
    [getPropertyData]: false,
    [getWorksOrdersApi]: false,
    [getCaseData]: false,
  });
  const handleApiError = (type: string) => {
    setApiErrors(prev => ({ ...prev, [type]: true }));
  };

  function getParamterValue(paramName: string) {
    let landingViewHref = globalThis.location.href,
      regexForcustomerSearchText = new RegExp(`[?&]${paramName}=([^&#]*)`, 'i');
    let regexForcustomerSearchTextResult = regexForcustomerSearchText.exec(landingViewHref);
    return regexForcustomerSearchTextResult?.[1] &&
      decodeURIComponent(regexForcustomerSearchTextResult[1].replaceAll('+', ' '))

  }


  const getReferenceData = async () => {
    if (isNullOrUndefined(localStorage.getItem('userName'))) {
      props.history.push("/Login")
      return;
    }

    try {
      let customerSearchText = getParamterValue('customerSearchText')
      let customerId = getParamterValue('customerId')
      dispatch(isSearch(true));
      dispatch(userChosenBackValue(null));
      dispatch(userChosenCurrentValue(null));
      dispatch(workOrderRepairObject(null));
      dispatch(loadDuplicateRepairPage(false));
      dispatch(userChosenResumeRepair(false));
      dispatch(userCreatedNewRepair(null));
      dispatch(saveSubSessionAssetsEligibilityDetails([]));

      const namespacenames = "search-types";
      const referenceDataresponsed = await api.getReferenceDataRepair(namespacenames);

      if (BackButton === true) {
        setIsSearchDropdown(true);
        if (SearchValue === SearchType.WorkOrder) {
          let RaisedSince = raisedSince;
          let RaisedUpto = raisedUpto;
          setRaisedSince(RaisedSince);
          setRaisedUpto(RaisedUpto);
        }
        setDisableSearchType(false);
        setSearchType(SearchValue);
        setSearchText(SearchText);
        setCurrentPage(0);
        setResultsPerPage(10);
        setSkip(0);
      } else {
        setDisableSearchType(true);
        setSearchType("Select");
        setSearchText("");
      }

      if (!isNullOrUndefined(customerId) && getPermissionsData?.indexOf(PermissionsList.view_open_crm) != -1) {
        dispatch(getCustomerId(customerId));
        dispatch(userChosenCustomerID(customerId));
        props.history.push('/Customer360View');
      }
      else if (!isNullOrUndefined(customerSearchText) && getPermissionsData?.indexOf(PermissionsList.view_open_crm) != -1) {
        // IVR Search mechanism for autoloading customer search with details of incoming customer call
        // Feature enabled only for customer hub agents
        setSearchType(SearchType.Customer);
        handleSubmit(customerSearchText);
        props.history.replace({ search: "" });
      }

      setAddresses(referenceDataresponsed[0]?.namespace.keyValues);
      setTimeout(() => { setIsLoading(false); }, 0);
    } catch (e) {
      if (
        typeof e === "object" && e !== null && "response" in e && typeof e.response === "object" && e.response !== null && "status" in e.response && e.response.status === 401) {
        localStorage.clear();
        props.history.replace("/Login");
      } else {
        console.error(e);
      }
    }

  };


  useEffect(() => {
    let tries = 0;
    let interval = setInterval(() => {
      const userName = localStorage.getItem('userName');
      if (userName) {
        clearInterval(interval);
      } else if (tries >= 20) {
        clearInterval(interval);
        props.history.replace("/Login");
      }
      tries += 1;
      dispatch(getSearchTypeWorkOrderData({
        setWorkOrderPropertyType: workOrderFilteredData?.setWorkOrderPropertyType,
        setStatusWorkOrderType: workOrderFilteredData?.setStatusWorkOrderType,
        setPriorityWorkOrder: workOrderFilteredData?.setPriorityWorkOrder
      }))

      dispatch(getSearchPropertyData({
        setPropertyStatus: propertyFilteredData?.setPropertyStatus,
        setPropertyType: propertyFilteredData?.setPropertyType
      }));
      dispatch(getSearchTypeServiceRequestData({
        setCasePropertyType: serviceRequestFilteredData?.setCasePropertyType,
        setCaseStatusFilterType: serviceRequestFilteredData?.setCaseStatusFilterType
      }))

      dispatch(getSearchTypeCustomerData({
        setCustomerStatus: customerFilteredData?.setCustomerStatus,
        setTenancyType: customerFilteredData?.setTenancyType,
      }));
    }, 100);
    return () => clearInterval(interval);

  }, [props.history]);



  useEffect(() => {
    if (!Array.isArray(getPermissionsData)) return;


    const hasLandingPageViewPermission =
      getPermissionsData.includes(PermissionsList.view_landing_page);
    if (SearchValue === "select" || SearchValue === null) {
      setDisableSearchType(true);
    } else {
      setDisableSearchType(false);
    }

    if (hasLandingPageViewPermission && cachedUserName) {
      const init = async () => {
        clearReduxStore();
        await getReferenceData();
      };
      init();
    } else {
      props.history.push("/Login");
    }
  }, [cachedUserName, getPermissionsData]);
   
  const clearReduxStore = () => {
    const state = {
      SearchText: SearchText,
      SearchType: SearchValue,
      BackButton: BackButton,
      Permissions: getPermissionsData,
      LoginStatus: loginStatus,
      isRepairMediaAllowed: isRepairMediaAllowed,
      searchTextCountValue: searchTextCountValue,
      vandalismtoggleValue: vandalismtoggleValue,
      isRepairCovidAllowed: isRepairCovidAllowed,
      demobilizedContractorSites: demobilizedContractorSites,
      isCaseAllowed: isCaseCheck,
      checkEnhancedRepairEligibilityP360: checkEnhancedRepairEligibilityP360,
      isEDEnabled: isEDEnabled,
      isDMQuestionnaireEnabled: isDMQuestionnaireEnabled,
      isDMReportPreferenceEnabled: isDMReportPreferenceEnabled,
      isHHRSReportPreferenceEnabled: isHHRSReportPreferenceEnabled,
      DMReportingComplianceEffectiveDate: DMReportingComplianceEffectiveDate,
      isAdditionalDMWorkOrderRequired: isAdditionalDMWorkOrderRequired,
      woCreationTimeoutSeconds: woCreationTimeoutSeconds,
      woCreationPollingDelaySeconds: woCreationPollingDelaySeconds,
      woCancellationTimeoutSeconds: woCancellationTimeoutSeconds,
      woCancellationPollingDelaySeconds: woCancellationPollingDelaySeconds,
      isCaseManagementToggle: caseManagementToggle,
      isUpdateAnActionToggle: updateAnActionToggle,
      edConfigOverrideUrl: edConfigOverrideUrl,
      edConfigCustomer: edConfigCustomer,
      isHHSRSEnabled: isHHSRSEnabled,
      isHHSRSRepairEnabled:isHHSRSRepairEnabledCheck,
      edConfigActiveHousingScriptUrl: edConfigActiveHousingScriptUrl,
      availabilityWaitTimeSeconds: availabilityWaitTimeSeconds,
      recallEligibilityPeriodInMonths: recallEligibilityPeriodInMonths,
      skipResponsibilityCheckForEMA: skipResponsibilityCheckForEMA
    };
    resetReduxState(dispatch, state);
    dispatch(resetHazardAssessmentData());
  };

  let fieldsArray: any[] = [];
  let arrayObject = Object.entries(addresses).filter(([_, value]) => {
    const permissions = Array.isArray(getPermissionsData) ? getPermissionsData : [];
    return !(
      (value === SearchType.WorkOrder && !permissions.includes(PermissionsList.view_work_order_360_view)) ||
      (value === SearchType.Servicerequest && !permissions.includes(PermissionsList.view_asset360_cases_search_for_case))
    );
  });

  arrayObject.forEach((eachLocation) => {
    if (isCaseCheck === 'false' && eachLocation[1] === 'Case') {
      return;
    }
    else {
      fieldsArray.push(
        <option key={eachLocation[0]} value={eachLocation[1]}>
          {eachLocation[1]}
        </option>)
    }
  })



  const handleChangeSearchType = (e: { target: { value: any } }) => {
    setRaisedSince(defaultfromdate);
    setRaisedUpto(defaultTodate);
    setIsSearchDropdown(false);
    setSearchType(e.target.value);
    dispatch(userChosenSearchType(e.target.value));
    setPropertyType('');
    setPropertyStatus('');
    setTenancyType('');
    setCustomerStatus('');
    setSearchText('');
    setStatusWorkOrderType('');
    setPriorityWorkOrder('');
    setWorkOrderPropertyType('');
    setCaseAssetType('');
    setCaseStatusType('');
    setIsDateValid(true);
    setIsAssignedToMe(false);
    if (e.target.value === t("select"))
      setDisableSearchType(true);
    else
      setDisableSearchType(false);
  }

  const handleSubmit = (search: any) => {
    setIsSearchDropdown(true);
    setSearchText(search);
    setCurrentPage(0);
    setResultsPerPage(10);
    setSkip(0);
    dispatch(userChosenBackButton(true));
    dispatch(userChosenSearchText(search));

  }

  const handleReset = () => {
    dispatch(getSearchTypeCustomerRemoveData({ setCustomerStatus: "", setTenancyType: "" }));
    dispatch(getSearchPropertyRemoveData({ setPropertyStatus: "", setPropertyType: "" }));
    dispatch(getSearchTypeWorkOrderDataRemove({ setWorkOrderPropertyType: "", setStatusWorkOrderType: "", setPriorityWorkOrder: "" }));
    dispatch(getSearchTypeServiceRequestDataRemove({ setCasePropertyType: "", setCaseStatusFilterType: "" }));
    dispatch(getSearchTypeSortDataRemove(""))
    dispatch(getCaseAssignToMeDataRemove(""));
    setShowFilter(false);
    setRaisedSince(defaultfromdate);
    setRaisedUpto(defaultTodate);
    setSortValue('');
    setPropertyType('');
    setPropertyStatus('');
    setPropertySortValue('');
    setCustomerStatus('');
    setTenancyType('');
    setStatusWorkOrderType('');
    setWorkOrderPropertyType('');
    setPriorityWorkOrder('');
    setCaseSortValue('');
    setCaseStatusType('');
    setCaseAssetType('');
    setIsDateValid(true);
    setDateErrorMessage('');
    setIsAssignedToMe(false);
    setIsSearchDropdown(true);
    setCurrentPage(0);
    setResultsPerPage(10);
    setSkip(0);
    handleSubmit(searchText);
    userChosenBackButton(false)
    globalThis.location.reload();
  };

  const RenderSearchComponents = () => {
    let component: any;
    switch (searchType) {
      case SearchType.Customer:
        if (apiErrorsStore?.includes(getCustomerData)) {
          component = (
            <div className="pt-5">
              <ErrorComponent input={[getCustomerData]} isbottomOfDom={false} customErrorMsg={t("Api_Error_MsgCustomerSearch")} />
            </div>
          );
        }
        else {
          component = (<CustomerResultComponent searchText={searchText} searchTextCount={Number(searchTextCount)}
            tenancyType={tenancyType} customerStatus={customerStatus} handleSort={handleChangeSortOrder}
            sortValue={sortValue} currentPage={currentPage} resultsPerPage={resultsPerPage}
            skip={skip} setShowFilter={showFilter}
            onApiError={() => handleApiError(getCustomerData)}
            {...props}>
          </CustomerResultComponent>)
        }
        break;
      case SearchType.Property:
        if (apiErrorsStore?.includes(getPropertyData)) {
          component = (
            <div className="pt-5">
              <ErrorComponent input={[getPropertyData]} isbottomOfDom={false} customErrorMsg={t("Api_Error_MsgAssetSearch")} />
            </div>
          ); 
        }
        else {
          component = (<PropertyResultComponent searchText={searchText}
            searchTextCount={Number(searchTextCount)} propertyType={propertyType}
            handleSort={handleChangeSortOrder} sortValue={propertySortValue} propertyStatus={propertyStatus}
            setShowFilter={showFilter}
            onApiError={() => handleApiError(getPropertyData)}
            {...props}>
          </PropertyResultComponent>)
        }

        break;
      case SearchType.WorkOrder:
        if (isDateValid && !apiErrorsStore?.includes(getWorksOrdersApi)) {
          component = (<WorkOrderResultComponent searchText={searchText}
            searchTextCount={Number(searchTextCount)}
            sortValue={propertySortValue} priority={priorityWorkOrder}
            status={statusWorkOrderType} raisedSince={raisedSince}
            raisedUpto={raisedUpto} propertyType={workOrderPropertyType}
            setShowFilter={showFilter}
            onApiError={() => handleApiError(getWorksOrdersApi)}
            {...props}>
          </WorkOrderResultComponent>)
        }
        else {
          component = (
            <div className="pt-5">
              <ErrorComponent input={[getWorksOrdersApi]} isbottomOfDom={false} customErrorMsg={t("Api_Error_MsgWOSearch")} />
            </div>
          );
        }
        break;
      case SearchType.Servicerequest:
        if (isDateValid && !apiErrorsStore?.includes(getCaseData)) {
          component = (<CaseResultComponent searchText={searchText}
            searchTextCount={Number(searchTextCount)} propertyType={caseAssetType} status={caseStatusType} isCaseAssignedToMe={isAssignedToMe}
            sortValue={caseSortValue} setShowFilter={showFilter} raisedSince={raisedSince}
            raisedUpto={raisedUpto}
            onApiError={() => handleApiError(getCaseData)}
            {...props}>
          </CaseResultComponent>)
        }
        else {
          component = (
            <div className="pt-5">
              <ErrorComponent input={[getCaseData]} isbottomOfDom={false} customErrorMsg={t("Api_Error_MsgCaseSearch")} />
            </div>
          );
        }
        break;
      default:
        component = null
    }

    return component;
  }

  const handleFilterSubmit = (customerStatus: any, tenancyType: any, propertyType: any, woFilter: any, caseFilter: any, propertyStatusType: any) => {
    setPropertyType(propertyType);
    setTenancyType(tenancyType);
    setCustomerStatus(customerStatus);
    setWorkOrderPropertyType(woFilter.workOrderPropertyType);
    setStatusWorkOrderType(woFilter.statusWorkOrderType);
    setPriorityWorkOrder(woFilter.priorityWorkOrder);
    setCaseAssetType(caseFilter.casePropertyType);
    setCaseStatusType(caseFilter.caseStatusType);
    setShowFilter(false);
    setPropertyStatus(propertyStatusType);
    setIsAssignedToMe(caseFilter.isCaseAssignedToMe);
  };

  const handelShowFilter = () => {
    dispatch(isSearch(true));
    if (searchType !== t("select")) setShowFilter(true);
  }

  const handleClose = () => {
    setShowFilter(false);
  }

  const handleResetSubmit = () => {
    setRaisedSince(defaultfromdate);
    setRaisedUpto(defaultTodate);
    setIsSearchDropdown(false);
    setPropertyType('');
    setTenancyType('');
    setCustomerStatus('');
    setWorkOrderPropertyType('');
    setStatusWorkOrderType('');
    setPriorityWorkOrder('');
  }
  const handleDateFrom = (targetValue: any) => {
    dispatch(userChosenRaisedSince(targetValue));
    setRaisedSince(targetValue);
    setIsDateValid(false);
    raisedSinceDate = targetValue;
    dateValidation();
  }
  const handleDateTo = (targetValue: any) => {
    setRaisedUpto(targetValue);
    dispatch(userChosenRaisedUpto(targetValue));
    setIsDateValid(false);
    raisedUptoDate = targetValue;
    dateValidation();
  }

  const dateValidation = () => {
    if (isNullOrUndefined(raisedSinceDate)) {
      raisedSinceDate = raisedSince;
    }
    if (isNullOrUndefined(raisedUptoDate)) {
      raisedUptoDate = raisedUpto;
    }
    const todayDate = formatDateTime(moment(new Date()).toString())
    if (raisedSinceDate > todayDate) {
      setDateErrorMessage(t("start_date_validation"))
      setIsDateValid(false);
    }
    else if (raisedUptoDate > todayDate) {
      setDateErrorMessage(t("end_date_validation"))
      setIsDateValid(false);
    }

    else if (raisedSinceDate > raisedUptoDate && raisedUptoDate != "") {
      setDateErrorMessage(t("valid_date_range"))
      setIsDateValid(false);
    }

    else {
      setRaisedSince(raisedSinceDate)
      setRaisedUpto(raisedUptoDate);
      setIsDateValid(true);
      setDateErrorMessage("");
    }
  }


  const handleChangeSortOrder = (e: { target: { value: string } }) => {
    // Storing sort data
    dispatch(getSearchTypeSortData(e.target.value))
    if (searchType === SearchType.Servicerequest) {
      setCaseSortValue(e.target.value);
    } else if (searchType === SearchType.Property || searchType === SearchType.WorkOrder) {
      setPropertySortValue(e.target.value)
    } else {
      setSortValue(e.target.value)
    }
  }
  const isWorkOrderOrServiceRequest = () => searchType === SearchType.WorkOrder || searchType === SearchType.Servicerequest;
  const isPropertyOrCustomer = () => searchType === SearchType.Property || searchType === SearchType.Customer;
  const isSmallScreen = () => window.screen.width < 820;
  const isLargeScreen = () => window.innerWidth > 820;

  const getSortValue = () => {
    if (isPropertyOrCustomer()) {
      return propertySortValue || sortValue || filteredSortData || "search.score() desc";
    }
    return propertySortValue || sortValue || filteredSortData;
  };

  const getContainerClassName = (isDateSort: boolean) => {
    if (isDateSort) {
      return isLargeScreen() ? "dskViewColumn2" : "flex items-center sm:w-full Spc-ml";
    }
    return "w-full md:w-5/12 lg:w-1/3 flex items-center mb-2 mt-3";
  };

  const getSelectClassName = (isDateSort: boolean) => {
    if (isDateSort) {
      return isSmallScreen() ? "MuiOutlinedInput-notchedOutline rounded W-lg bg-grey float-right srt-wid" : "MuiOutlinedInput-notchedOutline rounded srt-wid bg-grey";
    }
    return isSmallScreen() ? "MuiOutlinedInput-notchedOutline rounded W-lg bg-grey float-right ml-cf srt-wid" : "MuiOutlinedInput-notchedOutline rounded bg-grey w-1/2 mlshort";
  };

  const renderDateSortOptions = () => (
    <>
      <option value="raisedDate desc" selected={filteredSortData === "raisedDate desc"}>Newest to oldest</option>
      <option value="raisedDate asc" selected={filteredSortData === "raisedDate asc"}>Oldest to newest</option>
    </>
  );

  const renderAddressSortOptions = () => (
    <>
      <option value="address/addressLine1 asc" selected={filteredSortData === "address/addressLine1 asc"}>Address: Ascending</option>
      <option value="address/addressLine1 desc" selected={filteredSortData === "address/addressLine1 desc"}>Address: Descending</option>
    </>
  );

  const renderNameSortOptions = () => (
    <>
      <option value="surname" selected={filteredSortData === "surname"}>Name A to Z</option>
      <option value="surname desc" selected={filteredSortData === "surname desc"}>Name Z to A</option>
    </>
  );

  const renderCustomSortOptions = () => SearchType.Property === searchType ? renderAddressSortOptions() : renderNameSortOptions();

  //MuiOutlinedInput-notchedOutline for border 
  const displaySortOption = () => {
    if (isWorkOrderOrServiceRequest()) {
      return (
        <div className={getContainerClassName(true)}>
          <div className="w-full flex items-center mt-2">
            <div className="pr-1 text-date md:text-base pt-1  sm:w-mid mr-1 float-start"> Sort </div>
            <select
              data-testid=""
              id="case-search-sort1"
              className={getSelectClassName(true)}
              aria-label="case Search"
              value={filteredSortData}
              onChange={handleChangeSortOrder}
            >
              {renderDateSortOptions()}
            </select>
          </div>
        </div>
      );
    }
    
    if (isPropertyOrCustomer()) {
      return (
        <div className={getContainerClassName(false)}>
          <div className="md:w-1/2 md:w-auto md:text-left"> Sort </div>
          <select
            data-testid="webPropertySearchSort"
            id="property-search-sort1"
            className={getSelectClassName(false)}
            aria-label="Property Search"
            value={getSortValue()}
            onChange={handleChangeSortOrder}
          >
            <option value="search.score() desc">Best match</option>
            {renderCustomSortOptions()}
          </select>
        </div>
      );
    }
  }

  return (
    <>
      {globalThis.location.href.includes("/.auth/") ? (
        <div className="SpinnerWrapper">
          <LoadingSpinner />
        </div>
      ) : (
        <div>
          {isLoading ? (
            <div className="SpinnerWrapper">
              <LoadingSpinner />
            </div>
          ) : (
             <div className="border-grey bg-no-repeat bg-right-60% bg-50% md:bg-35% lg:bg-20% bg-fixed mt-1 min-ht px-4s">
              <div className="container ctn-fht mx-auto pb-12 my-5">
                <div className="w-full lg:px-0">
                  <h1 className="sm:font">{t("colleague_digital_Platform")}</h1>

                  <div className="w-3/4 md:text-left pt-2 pb-0 pl-1 global-txt">{t("pick_search_type")}</div>

                  <div className={`flex flex-col md:flex-row justify-between items-center mt-2 ${(searchType == "Select" || searchType == null) ? '' : 'border-b border-grey pb-4'}`}>
                    <div className="w-full md:w-3/12 lg:w-3/12 flex items-center mb-2">
                      <label className="w-full">
                        <select id="dropDownLand" className="block w-full mt-1 rounded border border-grey sm:mx-0 bg-grey" title="search"
                          value={searchType} onChange={handleChangeSearchType} data-testid="dropDownLocation" >
                          <option>{t("select")} </option>
                          {fieldsArray}
                        </select>
                      </label>
                    </div>

                    <div className="w-full lg:w-6/12 lg:mx-4 flex items-center mb-2">
                      <div id="custom-search-input" className={`block w-full mt-1 text-grey bg-grey topPosition rounded`}>
                        <label htmlFor="search-input" className="block">
                          <div className="input-group w-full" id="searchId">
                            <Search
                              id="search-input"
                              className="w-full"
                              defaultValue={searchText}
                              datatestid="search-text-button"
                              onSubmit={handleSubmit}
                              placeholder={t("seach_placeholder_txt")}
                              onClear={handleResetSubmit}
                              isDisabled={disableSearchType}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="w-full md:w-3/12 lg:w-3/12 flex items-center mb-2 sm:mt-4">
                      {searchText && <>
                        <div className="pr-4 mt-0">
                          <button type={undefined} className="text-teal no-underline hover:underline cursor-pointer a-style bg-transparent border-none p-0" onClick={handelShowFilter} data-testid="handle-show-filter">
                            <span className=" md:visible">{t("filter_txt")}</span>
                            <i className="fas fa-filter"></i>
                          </button>
                        </div>
                        <button type={undefined} className="text-teal no-underline hover:underline cursor-pointer a-style bg-transparent border-none p-0" data-testid="handle-reset" onClick={handleReset}>
                          <span className=" md:visible">{t("reset_txt")}</span>
                          <i className="fas fa-sync pl-1"></i>
                        </button></>}
                    </div>
                    <br></br>
                  </div>
                  <div className="border-b border-grey pb-4">
                    <div className="w-full flex items-center lg:mb-0 global-txt sm:flex-col mt-3">
                      {(searchType === SearchType.WorkOrder || searchType === SearchType.Servicerequest) &&
                        <>
                          <div className={window.innerWidth > 820 ? "dskViewColumn" : "md:w-2/3 flex items-center sm:w-full"}>
                            <label className="md:w-2/3 flex items-center md:pr-2 sm:w-full">
                              <div className={window.innerWidth < 820 ? "pr-1 md:w-1/2 text-date md:text-base pt-2 sm:w-mid float-start crt-wid" : "pr-1 md:w-1/2 text-date md:text-base pl-1 pt-2 sm:w-mid"}>
                                {t("Created_from")}</div>
                              <input data-testid="fromDate" id="fromdate" value={raisedSince} max="9999-12-31" type="date" onChange={e => handleDateFrom(e.target.value)} className={window.innerWidth < 820 ? "MuiOutlinedInput-notchedOutline text-sm md:text-base p-2 md:p-4 bg-grey W-lg float-right cal-wid rounded left" : "MuiOutlinedInput-notchedOutline text-sm md:text-base p-2 md:p-4 bg-grey Wid-PCSW rounded"}></input>
                              {window.innerWidth < 820 && <i className="input-group-text fa fa-calendar calendar" aria-hidden="true"></i>}
                            </label>
                          </div>

                          <div className={window.innerWidth > 820 ? "dskViewColumn1" : "md:w-2/3 flex items-center sm:w-full Spc-ml"}>
                            <label className="md:w-2/3 flex items-center md:pr-2 sm:w-full">
                              <div className={window.innerWidth < 820 ? "pr-1 md:w-1/2 text-date md:text-base pt-2 sm:w-mid float-start ml-XR rounded" : "pr-1 text-date md:text-base pt-2 sm:w-mid ml-XR rounded"} >
                                {t("Created_to")} </div>
                              <input data-testid="toDate" id="todate" type="date" value={raisedUpto} max="9999-12-31" onChange={e => handleDateTo(e.target.value)} className={window.innerWidth < 820 ? "MuiOutlinedInput-notchedOutline text-sm md:text-base p-2 md:p-4 bg-grey W-lg float-right cal-to-wid rounded left" : "MuiOutlinedInput-notchedOutline text-sm md:text-base p-2 md:p-4 bg-grey Wid-PCSW rounded"} />
                              {window.innerWidth < 820 && <i className="input-group-text fa fa-calendar calendar" aria-hidden="true"></i>}
                            </label>
                          </div>
                        </>}
                      {displaySortOption()}
                    </div>

                    {isDateValid ?
                      null
                      : <div className="w-full mt-4">
                        <div className="w-full px-4 py-2 bg-yellow flex items-center global-txt">
                          <div className="px-4 pr-8">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-brick-70 w-6 h-6"><path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path></svg>
                          </div>
                          <div className="flex items-center">
                            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                              {dateErrorMessage}
                            </p>
                          </div>
                        </div>
                      </div>}
                  </div>

                  {/* < -- Result view --> */}
                  {isSearchDropdown ? <RenderSearchComponents /> : null}

                  {/* < -- Side Filter view --> */}
                  {showFilter ? <FilterComponenent setFilter={handleFilterSubmit} handleClose={handleClose}
                    searchType={searchType} selectedCustomerStatus={customerStatus} selectedTenencyType={tenancyType} selectedPropertyType={propertyType} selectedWorkOrderPropertyType={workOrderPropertyType}
                    selectedStatusWorkOrderType={statusWorkOrderType} selectedPriorityWorkOrder={priorityWorkOrder} selectedCasePropertyType={caseAssetType} selectedCaseStatusFilter={caseStatusType}
                    selectedPropertyStatus={propertyStatus}
                    {...props} /> : null}

                </div></div></div>
            )
          }
        </div>
      )
      }
    </>
  );
}

export default LandingView